export default {
  // Wage
  getWageDoctors: state => state.wageDoctors,
  // Doctors
  getDoctors: state => state.doctors
}
